import { aiBacking } from "./aiBacking";
import type { AgentAnswer, AgentAnswers } from "./reviewRow.types";

export type EvidenceMark = "ok" | "warn" | "info";
export type EvidenceLine = { mark: EvidenceMark; text: string };

type Args = {
  agent: AgentAnswers | null;
  pickedPath: string | null;
  otherLabel: (answer: AgentAnswer) => string;
  proof: string;
};

const sure = (a: AgentAnswer, first: boolean) =>
  a.confidence === null
    ? a.model
    : `${a.model} ${Math.round(a.confidence * 100)}%${first ? " sure" : ""}`;

function aiLine(a: Args): EvidenceLine | null {
  const backing = aiBacking(a.agent, a.pickedPath);
  if (backing === null) return null;
  const answers = a.agent?.answers ?? [];
  if (backing === "all")
    return {
      mark: "ok",
      text: `${answers.length > 1 ? "Both AIs pick" : "The AI picks"} this field. ${answers.map((x, i) => sure(x, i === 0)).join(", ")}.`,
    };
  if (backing === "one") {
    const hit = answers.find((x) => x.path === a.pickedPath);
    const other = answers.find((x) => x.path !== a.pickedPath);
    const pct =
      !hit || hit.confidence === null
        ? ""
        : ` (${Math.round(hit.confidence * 100)}% sure)`;
    return {
      mark: "warn",
      text: `${hit?.model} picks this field${pct}.${other ? ` ${other.model} picks ${a.otherLabel(other)}.` : ""}`,
    };
  }
  return {
    mark: "info",
    text: "You picked this field. The AIs picked other fields.",
  };
}

export function evidenceLines(a: Args): EvidenceLine[] {
  const ai = aiLine(a);
  if (ai) return [ai];
  return a.proof ? [{ mark: "info", text: a.proof }] : [];
}
